/* @flow */
// typecheck: ignore file
import React from 'react';
import invariant from 'invariant';
import SmartTable from 'components/SmartTable.jsx';
import OrganizationClassesTableContainer from 'organizations/containers/OrganizationClassesTableContainer.jsx';

import './styles/AdminClassesTable.scss';

const nameSorts = [
  { key: 'name_asc', name: 'Ascending' },
  { key: 'name_desc', name: 'Descending' },
];

const createdAtSorts = [
  { key: 'created_at_asc', name: 'Ascending' },
  { key: 'created_at_desc', name: 'Descending' },
];

const COLUMNS = [
  { key: 'name', name: 'Name', sorts: nameSorts },
  { key: 'teacher_count', name: 'Teacher' },
  { key: 'message_count', name: 'Announcements' },
  { key: 'parent_count', name: 'Parents' },
  { key: 'created_at', name: 'Date created', sorts: createdAtSorts },
];

const INITIAL_SORT = 'name_asc';

type Props = {
  params: Object,
}

function AdminClassesTable(props: Props) {
  const { schoolId } = props.params;
  invariant(schoolId, 'school id missing in router param');
  const namespace = `admin-class-list-${props.params.schoolId}`;

  return (
    <div className="AdminClassesTable">
      <SmartTable data-test="smart-table" withSearch namespace={namespace} columns={COLUMNS} initialSort={INITIAL_SORT}>
        {({ query, sort }) => (
          <OrganizationClassesTableContainer
            organizationId={Number(schoolId)}
            query={query}
            sort={sort}
          />
        )}
      </SmartTable>
    </div>
  );
}

export default AdminClassesTable;



// WEBPACK FOOTER //
// ./src/admin/components/AdminClassesTable.jsx